exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".secondary-button{background-color:#b6102f;border-radius:4px;color:white;border:2px solid #b6102f;font-weight:700;width:220px;padding:10px}.secondary-button:disabled{background-color:#dddddd}.secondary-button:hover,.secondary-button:focus,.secondary-button:active{background-color:#F62D53;color:white;border:2px solid #F62D53;outline:none}.home-button-about{background-color:transparent;border-radius:4px;color:white;border:2px solid #FFFFFF;font-weight:700;width:220px;margin:40px;padding:10px}.home-button-about:enabled{background-color:transparent;color:white}.home-button-about:disabled{background-color:#dddddd}.home-button-about:hover{background-color:white;color:black;border:2px solid white}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Component/SecondaryButton.scss
// module id = 1048
// module chunks = 0